export default [
  {
    path: '/invoices',
    name: 'invoice-list',
    props: true,
    component: () => import('@/views/invoices/Index.vue'),
    meta: {

      requireLogin: true,
      pageTitle: 'Liste des Factures Fournisseur',
      description: 'Consultez, filtrez et gérez toutes les factures fournisseurs liées aux opérations logistiques. Accès rapide aux détails, statuts et actions.',
      accessibility: {
        landmark: 'main',
        ariaLabel: 'Liste des factures',
        help: 'Cette page présente la liste complète des factures fournisseurs. Utilisez les filtres pour affiner la recherche et accédez aux détails de chaque règlement.',
      },
      breadcrumb: [
        {
          text: 'Règlements',
          to: { name: 'invoice-list' },
        },
        {
          text: 'Liste des Règlements',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'supplier', 'accountant'],
    },
  },
  {
    path: '/invoices/create',
    name: 'invoice-add',
    props: true,
    component: () => import('@/views/invoices/Create.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Générer une Facture Fournisseur',
      description: 'Créez une nouvelle facture fournisseur en sélectionnant le partenaire et en générant le règlement correspondant.',
      accessibility: {
        landmark: 'form',
        ariaLabel: 'Formulaire de génération de facture',
        help: 'Complétez ce formulaire pour générer une facture fournisseur. Sélectionnez le fournisseur concerné puis validez.',
      },
      breadcrumb: [
        {
          text: 'Règlements',
          to: { name: 'invoice-list' },
        },
        {
          text: 'Ajouter Règlement',
          active: true,
        },
      ],
      roles: ['admin', 'accountant'],
    },
  },
  {
    path: '/invoices/preview/:id',
    name: 'invoice-preview',
    props: true,
    component: () => import('@/views/invoices/Preview.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Aperçu de la Facture Fournisseur',
      description: 'Vérifiez les commandes livrées et retournées pour le fournisseur sélectionné avant de valider la génération de la facture.',
      accessibility: {
        landmark: 'main',
        ariaLabel: 'Aperçu de la facture',
        help: 'Cette page affiche un aperçu détaillé des commandes à facturer pour le fournisseur sélectionné. Vérifiez les informations avant validation.',
      },
      breadcrumb: [
        {
          text: 'Règlements',
          to: { name: 'invoice-list' },
        },
        {
          text: 'Aperçu',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'accountant'],
    },
  },
  {
    path: '/invoices/batch-preview',
    name: 'batch-invoice-preview',
    props: true,
    component: () => import('@/views/invoices/BatchInvoicePreview.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Aperçu des Factures Multiples',
      description: 'Prévisualisez les factures pour plusieurs fournisseurs avant de les confirmer.',
      accessibility: {
        landmark: 'main',
        ariaLabel: 'Aperçu des factures multiples',
        help: 'Cette page affiche un aperçu des factures pour chaque fournisseur sélectionné. Vérifiez les détails avant de confirmer.',
      },
      breadcrumb: [
        {
          text: 'Règlements',
          to: { name: 'invoice-list' },
        },
        {
          text: 'Aperçu Multiple',
          active: true,
        },
      ],
      roles: ['admin', 'accountant'],
    },
  },
  {
    path: '/invoices/batch',
    name: 'batch-invoices',
    props: true,
    component: () => import('@/views/invoices/BatchInvoices.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Résultats de Génération de Factures',
      description: 'Consultez les résultats de la génération de factures en lot pour plusieurs fournisseurs.',
      accessibility: {
        landmark: 'main',
        ariaLabel: 'Résultats de génération de factures',
        help: 'Cette page affiche les résultats de la génération de factures en lot. Vous pouvez voir les factures créées et les erreurs éventuelles.',
      },
      breadcrumb: [
        {
          text: 'Règlements',
          to: { name: 'invoice-list' },
        },
        {
          text: 'Résultats',
          active: true,
        },
      ],
      roles: ['admin', 'accountant'],
    },
  },
  {
    path: '/invoices/print-all',
    name: 'print-all-invoices',
    props: true,
    component: () => import('@/views/invoices/PrintAll.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Imprimer Toutes les Factures',
      description: 'Imprimez toutes les factures sélectionnées en une seule fois.',
      roles: ['admin', 'superadmin', 'supplier', 'accountant'],
    },
  },
  {
    path: '/invoices/show/:id',
    name: 'invoice-show',
    props: true,
    component: () => import('@/views/invoices/Show.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Détails de la Facture Fournisseur',
      description: 'Consultez tous les détails d’une facture fournisseur : informations, statuts, montants, commandes associées et historique.',
      accessibility: {
        landmark: 'main',
        ariaLabel: 'Détails de la facture',
        help: 'Cette page présente la fiche complète d’une facture fournisseur, avec accès à l’historique, aux montants et aux commandes associées.',
      },
      breadcrumb: [
        {
          text: 'Règlements',
          to: { name: 'invoice-list' },
        },
        {
          text: 'Détails',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'supplier', 'accountant'],
    },
  },
  {
    path: '/invoices/direx',
    name: 'invoice-list-direx',
    props: true,
    component: () => import('@/views/invoicesProvider/Index.vue'),
    meta: {

      requireLogin: true,
      pageTitle: 'Liste des Factures à Payer',
      description: 'Visualisez la liste des factures fournisseurs en attente de paiement par la direction. Accédez aux détails et suivez le statut.',
      accessibility: {
        landmark: 'main',
        ariaLabel: 'Liste des factures à payer',
        help: 'Cette page présente la liste des factures à payer par la direction. Utilisez les filtres pour affiner la recherche.',
      },
      breadcrumb: [
        {
          text: 'Règlements',
          to: { name: 'invoice-list-direx' },
        },
        {
          text: 'Liste',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'admin_developer'],
    },
  },
  {
    path: '/invoices/direx/show/:id',
    name: 'invoice-show-direx',
    props: true,
    component: () => import('@/views/invoicesProvider/Show.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Détails de la Facture à Payer',
      description: 'Consultez les informations détaillées d’une facture à payer par la direction, avec historique et actions disponibles.',
      accessibility: {
        landmark: 'main',
        ariaLabel: 'Détails de la facture à payer',
        help: 'Cette page présente la fiche complète d’une facture à payer, avec accès à l’historique et aux actions de paiement.',
      },
      breadcrumb: [
        {
          text: 'Règlements',
          to: { name: 'invoice-list-direx' },
        },
        {
          text: 'Détails',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'admin_developer'],
    },
  },
  {
    path: '/invoices/direx/create',
    name: 'invoice-create-direx',
    props: true,
    component: () => import('@/views/invoicesProvider/Create.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Créer une Facture',
      description: 'Créez une nouvelle facture pour un client.',
      accessibility: {
        landmark: 'form',
        ariaLabel: 'Formulaire de création de facture',
        help: 'Remplissez ce formulaire pour créer une nouvelle facture.',
      },
      breadcrumb: [
        {
          text: 'Règlements',
          to: { name: 'invoice-list-direx' },
        },
        {
          text: 'Créer',
          active: true,
        },
      ],
      roles: ['admin_developer'], // Only admin_developer can create
    },
  },
  {
    path: '/invoices/direx/edit/:id',
    name: 'invoice-edit-direx',
    props: true,
    component: () => import('@/views/invoicesProvider/Edit.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Modifier une Facture',
      description: 'Modifiez une facture fournisseur existante.',
      accessibility: {
        landmark: 'form',
        ariaLabel: 'Formulaire de modification de facture',
        help: 'Modifiez les paramètres de la facture.',
      },
      breadcrumb: [
        {
          text: 'Règlements',
          to: { name: 'invoice-list-direx' },
        },
        {
          text: 'Modifier',
          active: true,
        },
      ],
      roles: ['admin_developer'], // Only admin_developer can edit
    },
  },
]
